export default __webpack_public_path__ + "static/media/320-100.240168e0.png";